import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ETFSSearchUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(data) {
        return await this.Repo.getETFSSearch(data);
    }
}
export default ETFSSearchUseCase;
